<template>
    <!-- <Basketball
        v-if="basketballObject"
        :object="basketballObject"
        :visible="visible"
        :layer="layer"
    />
    <Baseball v-if="baseballObject" :object="baseballObject" :visible="visible" :layer="layer" />
    <Football v-if="footballObject" :object="footballObject" :visible="visible" :layer="layer" /> -->

    <template v-for="item in data" :key="item.object.uuid">
        <component
            :is="item.component"
            :layer="layer"
            :visible="visible"
            :object="item.object"
            :s="item.s"
            :x="item.x"
            :y="item.y"
            :z="item.z"
            :rx="item.rx"
            :ry="item.ry"
            :rz="item.rz"
        />
    </template>
</template>

<script setup>
    import { computed, ref, shallowRef } from 'vue';

    import { usePane, useRafBool, useThreeObject } from '@resn/gozer-vue';

    import Baseball from './Baseball.vue';
    import Basketball from './Basketball.vue';
    import Football from './Football.vue';

    const props = defineProps({
        visible: { type: Boolean, default: false },
        object: { type: Object, default: null, required: true },
        layer: { type: Number, default: 0 },
        tier: { type: String, default: 'normal' },
    });

    const active = computed(() => props.visible);

    const basketballObject = props.object.getObjectByName('basketball').clone();
    const baseballObject = props.object.getObjectByName('baseball').clone();
    const footballObject = props.object.getObjectByName('football').clone();

    const data = shallowRef([
        { object: basketballObject, component: Basketball, s: 0.95, x: -0.13, y: -0.15, z: 0 }, // basketball
        { object: baseballObject, component: Baseball, s: 0.5, x: 0.14, y: -0.05, z: -0.3 }, // baseball
        {
            object: footballObject,
            component: Football,
            s: 0.772,
            x: -0.07,
            y: 0.08,
            z: -0.2,
            rx: 0.83,
            ry: 0.4,
            rz: 0.45,
        }, // football
    ]);

    const { object: multiSportObject } = useThreeObject(null, { name: 'MultiSport' });
    multiSportObject.add(basketballObject);
    multiSportObject.add(baseballObject);
    multiSportObject.add(footballObject);

    useRafBool(active, ({ delta }) => {
        // mesh.rotation.x += (delta / 1000) * 0.3;
    });
</script>
